import React, {Component} from 'react';
import {I18NContext} from '../../I18NContext';
import './AutoRefill.css';

interface MedicationCardManufacturerChangedLineProps {
    hasManufacturerChanged?: boolean;
    hasManufacturerChangedLabel?: string;
}

class MedicationCardManufacturerChangedLine extends Component<MedicationCardManufacturerChangedLineProps, {}> {
    render() {

        const {hasManufacturerChanged, hasManufacturerChangedLabel} = this.props;
        const imgClass = 'information-circle-blue-icon';

        return (
            <>
                {hasManufacturerChanged &&
                    (<pui-section flowdirection="horizontal" spacingTop="small" spacingBottom="small">
                            <pui-section-column>
                                <pui-icon imgClass={imgClass} spacingRight="mini"/>
                            </pui-section-column>
                            <pui-section flowdirection="vertical">
                                <pui-text input={hasManufacturerChangedLabel} inline/>
                            </pui-section>
                        </pui-section>
                    )
                }
            </>
        );
    }
}

MedicationCardManufacturerChangedLine.contextType = I18NContext;

export default MedicationCardManufacturerChangedLine;